import { useUnit } from 'effector-react';
import { useChanges } from '@nx-frontend/shared/hooks/useChangeEvents';
import { $pageBlocks } from '@nx-frontend/shared/store/portal-blocks';
import { isPersistantBlockType, PortalBlock } from '@nx-frontend/shared/types';
import { ChangeEvent, ChangeEventBase, ChangeEventType } from '@nx-frontend/shared/types';

type DeleteBlockPayload = Partial<Pick<ChangeEventBase<PortalBlock>, 'batchId' | 'collectId'>> & {
  blockId: string;
};

export const useDeleteBlock = (): ((payload: DeleteBlockPayload) => ChangeEvent | void) => {
  const [pageBlocks] = useUnit([$pageBlocks]);
  const setChanges = useChanges();

  return ({ blockId, batchId, collectId }) => {
    const block = pageBlocks.find((block: { id: string }) => block.id === blockId);
    if (block == null) {
      return console.warn(`Block not found, id:, ${blockId}`);
    }
    if (!isPersistantBlockType(block)) {
      return;
    }
    return setChanges({
      type: ChangeEventType.DELETE_BLOCK,
      oldValue: block,
      newValue: undefined,
      ...(batchId != null ? { batchId } : null),
      ...(collectId != null ? { collectId } : null),
    });
  };
};
